import { render, staticRenderFns } from "./showPartnersComponents.vue?vue&type=template&id=aea87e20"
import script from "./showPartnersComponents.vue?vue&type=script&lang=js"
export * from "./showPartnersComponents.vue?vue&type=script&lang=js"
import style0 from "./showPartnersComponents.vue?vue&type=style&index=0&id=aea87e20&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports